import { SVGIconProps } from "@faire/slate/icons/types";
import React from "react";

interface IProps {
  Icon?: React.FC<SVGIconProps>;
}

export const ToastIcon = ({ Icon }: IProps) => {
  return Icon ? (
    <div className="fs-toast__icon">
      <Icon color="inherit" titleAccess="" />
    </div>
  ) : null;
};
